import { useTranslation } from "react-i18next";
import { LoginModal } from "./login-modal";
import { MainBackgroundPage } from "../main-background-page";

export function Login() {
  const { t } = useTranslation();

  return (
    <div>
      <MainBackgroundPage />
      <LoginModal open={true} />
    </div>
  );
}
